import { z } from 'zod/v4';

export const applicationUserSchema = z.object({
  Email: z.string(),
  FirstName: z.string().nullable(),
  LastName: z.string().nullable(),
  Role: z.string(),
});

export type ApplicationUser = z.infer<typeof applicationUserSchema>;
